export enum LayoutPageAndMapPosition {
  TOP = 'ctx-mu-layout-page-and-map-top-position',
}
